<template>
  <a
    :href="href"
    :class="variant === 'small' ? 'btn-sm' : ''"
    class="btn text-nowrap btn-default btn-icon"
  >
    <slot></slot>
    <ChevronRight class="svg-16 ml-1" />
  </a>
</template>

<script>
import ChevronRight from "../../icons/atalanda/chevron-right.svg";

export default {
  name: "ActionButton",
  components: {
    ChevronRight,
  },
  props: {
    href: {
      type: String,
      required: true,
    },
    variant: {
      type: String,
      required: false,
      default: "normal",
    },
  },
};
</script>
